// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2v2L8","additionalInfo":"AgreementModal_additionalInfo__IjiUn"};